(function (f) {
  if (typeof exports === "object" && typeof module !== "undefined") {
    module.exports = f();
  } else if (typeof define === "function" && define.amd) {
    define([], f);
  } else {
    var g;

    if (typeof window !== "undefined") {
      g = window;
    } else if (typeof global !== "undefined") {
      g = global;
    } else if (typeof self !== "undefined") {
      g = self;
    } else {
      g = this;
    }

    g.realisticStructuredClone = f();
  }
})(function () {
  var define, module, exports;
  return function () {
    function e(t, n, r) {
      function s(o, u) {
        if (!n[o]) {
          if (!t[o]) {
            var a = typeof require == "function" && require;
            if (!u && a) return a(o, !0);
            if (i) return i(o, !0);
            var f = new Error("Cannot find module '" + o + "'");
            throw f.code = "MODULE_NOT_FOUND", f;
          }

          var l = n[o] = {
            exports: {}
          };
          t[o][0].call(l.exports, function (e) {
            var n = t[o][1][e];
            return s(n ? n : e);
          }, l, l.exports, e, t, n, r);
        }

        return n[o].exports;
      }

      var i = typeof require == "function" && require;

      for (var o = 0; o < r.length; o++) {
        s(r[o]);
      }

      return s;
    }

    return e;
  }()({
    1: [function (_dereq_, module, exports) {
      'use strict';

      _dereq_('core-js/fn/array/includes');

      _dereq_('core-js/fn/object/values');

      var DOMException = _dereq_('domexception');

      var Typeson = _dereq_('typeson');

      var structuredCloningThrowing = _dereq_('typeson-registry/dist/presets/structured-cloning-throwing'); // http://stackoverflow.com/a/33268326/786644 - works in browser, worker, and Node.js


      var globalVar = typeof window !== 'undefined' ? window : typeof WorkerGlobalScope !== 'undefined' ? self : typeof global !== 'undefined' ? global : Function('return this;')();

      if (!globalVar.DOMException) {
        globalVar.DOMException = DOMException;
      }

      var TSON = new Typeson().register(structuredCloningThrowing);

      function realisticStructuredClone(obj) {
        return TSON.revive(TSON.encapsulate(obj));
      }

      module.exports = realisticStructuredClone;
    }, {
      "core-js/fn/array/includes": 2,
      "core-js/fn/object/values": 3,
      "domexception": 44,
      "typeson": 47,
      "typeson-registry/dist/presets/structured-cloning-throwing": 46
    }],
    2: [function (_dereq_, module, exports) {
      'use strict';

      _dereq_('../../modules/es7.array.includes');

      module.exports = _dereq_('../../modules/_core').Array.includes;
    }, {
      "../../modules/_core": 9,
      "../../modules/es7.array.includes": 39
    }],
    3: [function (_dereq_, module, exports) {
      'use strict';

      _dereq_('../../modules/es7.object.values');

      module.exports = _dereq_('../../modules/_core').Object.values;
    }, {
      "../../modules/_core": 9,
      "../../modules/es7.object.values": 40
    }],
    4: [function (_dereq_, module, exports) {
      'use strict';

      module.exports = function (it) {
        if (typeof it != 'function') throw TypeError(it + ' is not a function!');
        return it;
      };
    }, {}],
    5: [function (_dereq_, module, exports) {
      'use strict'; // 22.1.3.31 Array.prototype[@@unscopables]

      var UNSCOPABLES = _dereq_('./_wks')('unscopables');

      var ArrayProto = Array.prototype;
      if (ArrayProto[UNSCOPABLES] == undefined) _dereq_('./_hide')(ArrayProto, UNSCOPABLES, {});

      module.exports = function (key) {
        ArrayProto[UNSCOPABLES][key] = true;
      };
    }, {
      "./_hide": 19,
      "./_wks": 38
    }],
    6: [function (_dereq_, module, exports) {
      'use strict';

      var isObject = _dereq_('./_is-object');

      module.exports = function (it) {
        if (!isObject(it)) throw TypeError(it + ' is not an object!');
        return it;
      };
    }, {
      "./_is-object": 22
    }],
    7: [function (_dereq_, module, exports) {
      'use strict'; // false -> Array#indexOf
      // true  -> Array#includes

      var toIObject = _dereq_('./_to-iobject');

      var toLength = _dereq_('./_to-length');

      var toAbsoluteIndex = _dereq_('./_to-absolute-index');

      module.exports = function (IS_INCLUDES) {
        return function ($this, el, fromIndex) {
          var O = toIObject($this);
          var length = toLength(O.length);
          var index = toAbsoluteIndex(fromIndex, length);
          var value; // Array#includes uses SameValueZero equality algorithm
          // eslint-disable-next-line no-self-compare

          if (IS_INCLUDES && el != el) while (length > index) {
            value = O[index++]; // eslint-disable-next-line no-self-compare

            if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
          } else for (; length > index; index++) {
            if (IS_INCLUDES || index in O) {
              if (O[index] === el) return IS_INCLUDES || index || 0;
            }
          }
          return !IS_INCLUDES && -1;
        };
      };
    }, {
      "./_to-absolute-index": 32,
      "./_to-iobject": 34,
      "./_to-length": 35
    }],
    8: [function (_dereq_, module, exports) {
      "use strict";

      var toString = {}.toString;

      module.exports = function (it) {
        return toString.call(it).slice(8, -1);
      };
    }, {}],
    9: [function (_dereq_, module, exports) {
      'use strict';

      var core = module.exports = {
        version: '2.5.3'
      };
      if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
    }, {}],
    10: [function (_dereq_, module, exports) {
      'use strict'; // optional / simple context binding

      var aFunction = _dereq_('./_a-function');

      module.exports = function (fn, that, length) {
        aFunction(fn);
        if (that === undefined) return fn;

        switch (length) {
          case 1:
            return function (a) {
              return fn.call(that, a);
            };

          case 2:
            return function (a, b) {
              return fn.call(that, a, b);
            };

          case 3:
            return function (a, b, c) {
              return fn.call(that, a, b, c);
            };
        }

        return function ()
        /* ...args */
        {
          return fn.apply(that, arguments);
        };
      };
    }, {
      "./_a-function": 4
    }],
    11: [function (_dereq_, module, exports) {
      "use strict"; // 7.2.1 RequireObjectCoercible(argument)

      module.exports = function (it) {
        if (it == undefined) throw TypeError("Can't call method on  " + it);
        return it;
      };
    }, {}],
    12: [function (_dereq_, module, exports) {
      'use strict'; // Thank's IE8 for his funny defineProperty

      module.exports = !_dereq_('./_fails')(function () {
        return Object.defineProperty({}, 'a', {
          get: function get() {
            return 7;
          }
        }).a != 7;
      });
    }, {
      "./_fails": 16
    }],
    13: [function (_dereq_, module, exports) {
      'use strict';

      var isObject = _dereq_('./_is-object');

      var document = _dereq_('./_global').document; // typeof document.createElement is 'object' in old IE


      var is = isObject(document) && isObject(document.createElement);

      module.exports = function (it) {
        return is ? document.createElement(it) : {};
      };
    }, {
      "./_global": 17,
      "./_is-object": 22
    }],
    14: [function (_dereq_, module, exports) {
      'use strict'; // IE 8- don't enum bug keys

      module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
    }, {}],
    15: [function (_dereq_, module, exports) {
      'use strict';

      var global = _dereq_('./_global');

      var core = _dereq_('./_core');

      var hide = _dereq_('./_hide');

      var redefine = _dereq_('./_redefine');

      var ctx = _dereq_('./_ctx');

      var PROTOTYPE = 'prototype';

      var $export = function $export(type, name, source) {
        var IS_FORCED = type & $export.F;
        var IS_GLOBAL = type & $export.G;
        var IS_STATIC = type & $export.S;
        var IS_PROTO = type & $export.P;
        var IS_BIND = type & $export.B;
        var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
        var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
        var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
        var key, own, out, exp;
        if (IS_GLOBAL) source = name;

        for (key in source) {
          // contains in native
          own = !IS_FORCED && target && target[key] !== undefined; // export native or passed

          out = (own ? target : source)[key]; // bind timers to global for call from export context

          exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out; // extend global

          if (target) redefine(target, key, out, type & $export.U); // export

          if (exports[key] != out) hide(exports, key, exp);
          if (IS_PROTO && expProto[key] != out) expProto[key] = out;
        }
      };

      global.core = core; // type bitmap

      $export.F = 1; // forced

      $export.G = 2; // global

      $export.S = 4; // static

      $export.P = 8; // proto

      $export.B = 16; // bind

      $export.W = 32; // wrap

      $export.U = 64; // safe

      $export.R = 128; // real proto method for `library`

      module.exports = $export;
    }, {
      "./_core": 9,
      "./_ctx": 10,
      "./_global": 17,
      "./_hide": 19,
      "./_redefine": 29
    }],
    16: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (exec) {
        try {
          return !!exec();
        } catch (e) {
          return true;
        }
      };
    }, {}],
    17: [function (_dereq_, module, exports) {
      'use strict'; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028

      var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
      : Function('return this')();
      if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
    }, {}],
    18: [function (_dereq_, module, exports) {
      "use strict";

      var hasOwnProperty = {}.hasOwnProperty;

      module.exports = function (it, key) {
        return hasOwnProperty.call(it, key);
      };
    }, {}],
    19: [function (_dereq_, module, exports) {
      'use strict';

      var dP = _dereq_('./_object-dp');

      var createDesc = _dereq_('./_property-desc');

      module.exports = _dereq_('./_descriptors') ? function (object, key, value) {
        return dP.f(object, key, createDesc(1, value));
      } : function (object, key, value) {
        object[key] = value;
        return object;
      };
    }, {
      "./_descriptors": 12,
      "./_object-dp": 23,
      "./_property-desc": 28
    }],
    20: [function (_dereq_, module, exports) {
      'use strict';

      module.exports = !_dereq_('./_descriptors') && !_dereq_('./_fails')(function () {
        return Object.defineProperty(_dereq_('./_dom-create')('div'), 'a', {
          get: function get() {
            return 7;
          }
        }).a != 7;
      });
    }, {
      "./_descriptors": 12,
      "./_dom-create": 13,
      "./_fails": 16
    }],
    21: [function (_dereq_, module, exports) {
      'use strict'; // fallback for non-array-like ES3 and non-enumerable old V8 strings

      var cof = _dereq_('./_cof'); // eslint-disable-next-line no-prototype-builtins


      module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
        return cof(it) == 'String' ? it.split('') : Object(it);
      };
    }, {
      "./_cof": 8
    }],
    22: [function (_dereq_, module, exports) {
      'use strict';

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      module.exports = function (it) {
        return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
      };
    }, {}],
    23: [function (_dereq_, module, exports) {
      'use strict';

      var anObject = _dereq_('./_an-object');

      var IE8_DOM_DEFINE = _dereq_('./_ie8-dom-define');

      var toPrimitive = _dereq_('./_to-primitive');

      var dP = Object.defineProperty;
      exports.f = _dereq_('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPrimitive(P, true);
        anObject(Attributes);
        if (IE8_DOM_DEFINE) try {
          return dP(O, P, Attributes);
        } catch (e) {
          /* empty */
        }
        if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
        if ('value' in Attributes) O[P] = Attributes.value;
        return O;
      };
    }, {
      "./_an-object": 6,
      "./_descriptors": 12,
      "./_ie8-dom-define": 20,
      "./_to-primitive": 36
    }],
    24: [function (_dereq_, module, exports) {
      'use strict';

      var has = _dereq_('./_has');

      var toIObject = _dereq_('./_to-iobject');

      var arrayIndexOf = _dereq_('./_array-includes')(false);

      var IE_PROTO = _dereq_('./_shared-key')('IE_PROTO');

      module.exports = function (object, names) {
        var O = toIObject(object);
        var i = 0;
        var result = [];
        var key;

        for (key in O) {
          if (key != IE_PROTO) has(O, key) && result.push(key);
        } // Don't enum bug & hidden keys


        while (names.length > i) {
          if (has(O, key = names[i++])) {
            ~arrayIndexOf(result, key) || result.push(key);
          }
        }

        return result;
      };
    }, {
      "./_array-includes": 7,
      "./_has": 18,
      "./_shared-key": 30,
      "./_to-iobject": 34
    }],
    25: [function (_dereq_, module, exports) {
      'use strict'; // 19.1.2.14 / 15.2.3.14 Object.keys(O)

      var $keys = _dereq_('./_object-keys-internal');

      var enumBugKeys = _dereq_('./_enum-bug-keys');

      module.exports = Object.keys || function keys(O) {
        return $keys(O, enumBugKeys);
      };
    }, {
      "./_enum-bug-keys": 14,
      "./_object-keys-internal": 24
    }],
    26: [function (_dereq_, module, exports) {
      "use strict";

      exports.f = {}.propertyIsEnumerable;
    }, {}],
    27: [function (_dereq_, module, exports) {
      'use strict';

      var getKeys = _dereq_('./_object-keys');

      var toIObject = _dereq_('./_to-iobject');

      var isEnum = _dereq_('./_object-pie').f;

      module.exports = function (isEntries) {
        return function (it) {
          var O = toIObject(it);
          var keys = getKeys(O);
          var length = keys.length;
          var i = 0;
          var result = [];
          var key;

          while (length > i) {
            if (isEnum.call(O, key = keys[i++])) {
              result.push(isEntries ? [key, O[key]] : O[key]);
            }
          }

          return result;
        };
      };
    }, {
      "./_object-keys": 25,
      "./_object-pie": 26,
      "./_to-iobject": 34
    }],
    28: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = function (bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value: value
        };
      };
    }, {}],
    29: [function (_dereq_, module, exports) {
      'use strict';

      var global = _dereq_('./_global');

      var hide = _dereq_('./_hide');

      var has = _dereq_('./_has');

      var SRC = _dereq_('./_uid')('src');

      var TO_STRING = 'toString';
      var $toString = Function[TO_STRING];
      var TPL = ('' + $toString).split(TO_STRING);

      _dereq_('./_core').inspectSource = function (it) {
        return $toString.call(it);
      };

      (module.exports = function (O, key, val, safe) {
        var isFunction = typeof val == 'function';
        if (isFunction) has(val, 'name') || hide(val, 'name', key);
        if (O[key] === val) return;
        if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));

        if (O === global) {
          O[key] = val;
        } else if (!safe) {
          delete O[key];
          hide(O, key, val);
        } else if (O[key]) {
          O[key] = val;
        } else {
          hide(O, key, val);
        } // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative

      })(Function.prototype, TO_STRING, function toString() {
        return typeof this == 'function' && this[SRC] || $toString.call(this);
      });
    }, {
      "./_core": 9,
      "./_global": 17,
      "./_has": 18,
      "./_hide": 19,
      "./_uid": 37
    }],
    30: [function (_dereq_, module, exports) {
      'use strict';

      var shared = _dereq_('./_shared')('keys');

      var uid = _dereq_('./_uid');

      module.exports = function (key) {
        return shared[key] || (shared[key] = uid(key));
      };
    }, {
      "./_shared": 31,
      "./_uid": 37
    }],
    31: [function (_dereq_, module, exports) {
      'use strict';

      var global = _dereq_('./_global');

      var SHARED = '__core-js_shared__';
      var store = global[SHARED] || (global[SHARED] = {});

      module.exports = function (key) {
        return store[key] || (store[key] = {});
      };
    }, {
      "./_global": 17
    }],
    32: [function (_dereq_, module, exports) {
      'use strict';

      var toInteger = _dereq_('./_to-integer');

      var max = Math.max;
      var min = Math.min;

      module.exports = function (index, length) {
        index = toInteger(index);
        return index < 0 ? max(index + length, 0) : min(index, length);
      };
    }, {
      "./_to-integer": 33
    }],
    33: [function (_dereq_, module, exports) {
      "use strict"; // 7.1.4 ToInteger

      var ceil = Math.ceil;
      var floor = Math.floor;

      module.exports = function (it) {
        return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
      };
    }, {}],
    34: [function (_dereq_, module, exports) {
      'use strict'; // to indexed object, toObject with fallback for non-array-like ES3 strings

      var IObject = _dereq_('./_iobject');

      var defined = _dereq_('./_defined');

      module.exports = function (it) {
        return IObject(defined(it));
      };
    }, {
      "./_defined": 11,
      "./_iobject": 21
    }],
    35: [function (_dereq_, module, exports) {
      'use strict'; // 7.1.15 ToLength

      var toInteger = _dereq_('./_to-integer');

      var min = Math.min;

      module.exports = function (it) {
        return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
      };
    }, {
      "./_to-integer": 33
    }],
    36: [function (_dereq_, module, exports) {
      'use strict'; // 7.1.1 ToPrimitive(input [, PreferredType])

      var isObject = _dereq_('./_is-object'); // instead of the ES6 spec version, we didn't implement @@toPrimitive case
      // and the second argument - flag - preferred type is a string


      module.exports = function (it, S) {
        if (!isObject(it)) return it;
        var fn, val;
        if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
        if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
        if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
        throw TypeError("Can't convert object to primitive value");
      };
    }, {
      "./_is-object": 22
    }],
    37: [function (_dereq_, module, exports) {
      'use strict';

      var id = 0;
      var px = Math.random();

      module.exports = function (key) {
        return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
      };
    }, {}],
    38: [function (_dereq_, module, exports) {
      'use strict';

      var store = _dereq_('./_shared')('wks');

      var uid = _dereq_('./_uid');

      var _Symbol = _dereq_('./_global').Symbol;

      var USE_SYMBOL = typeof _Symbol == 'function';

      var $exports = module.exports = function (name) {
        return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
      };

      $exports.store = store;
    }, {
      "./_global": 17,
      "./_shared": 31,
      "./_uid": 37
    }],
    39: [function (_dereq_, module, exports) {
      'use strict'; // https://github.com/tc39/Array.prototype.includes

      var $export = _dereq_('./_export');

      var $includes = _dereq_('./_array-includes')(true);

      $export($export.P, 'Array', {
        includes: function includes(el
        /* , fromIndex = 0 */
        ) {
          return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
        }
      });

      _dereq_('./_add-to-unscopables')('includes');
    }, {
      "./_add-to-unscopables": 5,
      "./_array-includes": 7,
      "./_export": 15
    }],
    40: [function (_dereq_, module, exports) {
      'use strict'; // https://github.com/tc39/proposal-object-values-entries

      var $export = _dereq_('./_export');

      var $values = _dereq_('./_object-to-array')(false);

      $export($export.S, 'Object', {
        values: function values(it) {
          return $values(it);
        }
      });
    }, {
      "./_export": 15,
      "./_object-to-array": 27
    }],
    41: [function (_dereq_, module, exports) {
      "use strict";

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;
          var _e = undefined;

          try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }

          return _arr;
        }

        return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var legacyErrorCodes = _dereq_("./legacy-error-codes.json");

      var idlUtils = _dereq_("./utils.js");

      exports.implementation = function () {
        function DOMExceptionImpl(_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              message = _ref2[0],
              name = _ref2[1];

          _classCallCheck(this, DOMExceptionImpl);

          this.name = name;
          this.message = message;
        }

        _createClass(DOMExceptionImpl, [{
          key: "code",
          get: function get() {
            return legacyErrorCodes[this.name] || 0;
          }
        }]);

        return DOMExceptionImpl;
      }(); // A proprietary V8 extension that causes the stack property to appear.


      exports.init = function (impl) {
        if (Error.captureStackTrace) {
          var wrapper = idlUtils.wrapperForImpl(impl);
          Error.captureStackTrace(wrapper, wrapper.constructor);
        }
      };
    }, {
      "./legacy-error-codes.json": 43,
      "./utils.js": 45
    }],
    42: [function (_dereq_, module, exports) {
      "use strict";

      var conversions = _dereq_("webidl-conversions");

      var utils = _dereq_("./utils.js");

      var impl = utils.implSymbol;

      function DOMException() {
        var args = [];

        for (var i = 0; i < arguments.length && i < 2; ++i) {
          args[i] = arguments[i];
        }

        if (args[0] !== undefined) {
          args[0] = conversions["DOMString"](args[0], {
            context: "Failed to construct 'DOMException': parameter 1"
          });
        } else {
          args[0] = "";
        }

        if (args[1] !== undefined) {
          args[1] = conversions["DOMString"](args[1], {
            context: "Failed to construct 'DOMException': parameter 2"
          });
        } else {
          args[1] = "Error";
        }

        iface.setup(this, args);
      }

      Object.defineProperty(DOMException, "prototype", {
        value: DOMException.prototype,
        writable: false,
        enumerable: false,
        configurable: false
      });
      Object.defineProperty(DOMException.prototype, "name", {
        get: function get() {
          return this[impl]["name"];
        },
        enumerable: true,
        configurable: true
      });
      Object.defineProperty(DOMException.prototype, "message", {
        get: function get() {
          return this[impl]["message"];
        },
        enumerable: true,
        configurable: true
      });
      Object.defineProperty(DOMException.prototype, "code", {
        get: function get() {
          return this[impl]["code"];
        },
        enumerable: true,
        configurable: true
      });
      Object.defineProperty(DOMException, "INDEX_SIZE_ERR", {
        value: 1,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "INDEX_SIZE_ERR", {
        value: 1,
        enumerable: true
      });
      Object.defineProperty(DOMException, "DOMSTRING_SIZE_ERR", {
        value: 2,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "DOMSTRING_SIZE_ERR", {
        value: 2,
        enumerable: true
      });
      Object.defineProperty(DOMException, "HIERARCHY_REQUEST_ERR", {
        value: 3,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "HIERARCHY_REQUEST_ERR", {
        value: 3,
        enumerable: true
      });
      Object.defineProperty(DOMException, "WRONG_DOCUMENT_ERR", {
        value: 4,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "WRONG_DOCUMENT_ERR", {
        value: 4,
        enumerable: true
      });
      Object.defineProperty(DOMException, "INVALID_CHARACTER_ERR", {
        value: 5,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "INVALID_CHARACTER_ERR", {
        value: 5,
        enumerable: true
      });
      Object.defineProperty(DOMException, "NO_DATA_ALLOWED_ERR", {
        value: 6,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "NO_DATA_ALLOWED_ERR", {
        value: 6,
        enumerable: true
      });
      Object.defineProperty(DOMException, "NO_MODIFICATION_ALLOWED_ERR", {
        value: 7,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "NO_MODIFICATION_ALLOWED_ERR", {
        value: 7,
        enumerable: true
      });
      Object.defineProperty(DOMException, "NOT_FOUND_ERR", {
        value: 8,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "NOT_FOUND_ERR", {
        value: 8,
        enumerable: true
      });
      Object.defineProperty(DOMException, "NOT_SUPPORTED_ERR", {
        value: 9,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "NOT_SUPPORTED_ERR", {
        value: 9,
        enumerable: true
      });
      Object.defineProperty(DOMException, "INUSE_ATTRIBUTE_ERR", {
        value: 10,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "INUSE_ATTRIBUTE_ERR", {
        value: 10,
        enumerable: true
      });
      Object.defineProperty(DOMException, "INVALID_STATE_ERR", {
        value: 11,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "INVALID_STATE_ERR", {
        value: 11,
        enumerable: true
      });
      Object.defineProperty(DOMException, "SYNTAX_ERR", {
        value: 12,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "SYNTAX_ERR", {
        value: 12,
        enumerable: true
      });
      Object.defineProperty(DOMException, "INVALID_MODIFICATION_ERR", {
        value: 13,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "INVALID_MODIFICATION_ERR", {
        value: 13,
        enumerable: true
      });
      Object.defineProperty(DOMException, "NAMESPACE_ERR", {
        value: 14,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "NAMESPACE_ERR", {
        value: 14,
        enumerable: true
      });
      Object.defineProperty(DOMException, "INVALID_ACCESS_ERR", {
        value: 15,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "INVALID_ACCESS_ERR", {
        value: 15,
        enumerable: true
      });
      Object.defineProperty(DOMException, "VALIDATION_ERR", {
        value: 16,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "VALIDATION_ERR", {
        value: 16,
        enumerable: true
      });
      Object.defineProperty(DOMException, "TYPE_MISMATCH_ERR", {
        value: 17,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "TYPE_MISMATCH_ERR", {
        value: 17,
        enumerable: true
      });
      Object.defineProperty(DOMException, "SECURITY_ERR", {
        value: 18,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "SECURITY_ERR", {
        value: 18,
        enumerable: true
      });
      Object.defineProperty(DOMException, "NETWORK_ERR", {
        value: 19,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "NETWORK_ERR", {
        value: 19,
        enumerable: true
      });
      Object.defineProperty(DOMException, "ABORT_ERR", {
        value: 20,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "ABORT_ERR", {
        value: 20,
        enumerable: true
      });
      Object.defineProperty(DOMException, "URL_MISMATCH_ERR", {
        value: 21,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "URL_MISMATCH_ERR", {
        value: 21,
        enumerable: true
      });
      Object.defineProperty(DOMException, "QUOTA_EXCEEDED_ERR", {
        value: 22,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "QUOTA_EXCEEDED_ERR", {
        value: 22,
        enumerable: true
      });
      Object.defineProperty(DOMException, "TIMEOUT_ERR", {
        value: 23,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "TIMEOUT_ERR", {
        value: 23,
        enumerable: true
      });
      Object.defineProperty(DOMException, "INVALID_NODE_TYPE_ERR", {
        value: 24,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "INVALID_NODE_TYPE_ERR", {
        value: 24,
        enumerable: true
      });
      Object.defineProperty(DOMException, "DATA_CLONE_ERR", {
        value: 25,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, "DATA_CLONE_ERR", {
        value: 25,
        enumerable: true
      });
      Object.defineProperty(DOMException.prototype, Symbol.toStringTag, {
        value: "DOMException",
        writable: false,
        enumerable: false,
        configurable: true
      });
      var iface = {
        mixedInto: [],
        is: function is(obj) {
          if (obj) {
            if (obj[impl] instanceof Impl.implementation) {
              return true;
            }

            for (var i = 0; i < module.exports.mixedInto.length; ++i) {
              if (obj instanceof module.exports.mixedInto[i]) {
                return true;
              }
            }
          }

          return false;
        },
        isImpl: function isImpl(obj) {
          if (obj) {
            if (obj instanceof Impl.implementation) {
              return true;
            }

            var wrapper = utils.wrapperForImpl(obj);

            for (var i = 0; i < module.exports.mixedInto.length; ++i) {
              if (wrapper instanceof module.exports.mixedInto[i]) {
                return true;
              }
            }
          }

          return false;
        },
        convert: function convert(obj) {
          var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              _ref$context = _ref.context,
              context = _ref$context === undefined ? "The provided value" : _ref$context;

          if (module.exports.is(obj)) {
            return utils.implForWrapper(obj);
          }

          throw new TypeError(context + " is not of type 'DOMException'.");
        },
        create: function create(constructorArgs, privateData) {
          var obj = Object.create(DOMException.prototype);
          this.setup(obj, constructorArgs, privateData);
          return obj;
        },
        createImpl: function createImpl(constructorArgs, privateData) {
          var obj = Object.create(DOMException.prototype);
          this.setup(obj, constructorArgs, privateData);
          return utils.implForWrapper(obj);
        },
        _internalSetup: function _internalSetup(obj) {},
        setup: function setup(obj, constructorArgs, privateData) {
          if (!privateData) privateData = {};
          privateData.wrapper = obj;

          this._internalSetup(obj);

          Object.defineProperty(obj, impl, {
            value: new Impl.implementation(constructorArgs, privateData),
            writable: false,
            enumerable: false,
            configurable: true
          });
          obj[impl][utils.wrapperSymbol] = obj;

          if (Impl.init) {
            Impl.init(obj[impl], privateData);
          }
        },
        interface: DOMException,
        expose: {
          Window: {
            DOMException: DOMException
          },
          Worker: {
            DOMException: DOMException
          }
        }
      }; // iface

      module.exports = iface;

      var Impl = _dereq_(".//DOMException-impl.js");
    }, {
      ".//DOMException-impl.js": 41,
      "./utils.js": 45,
      "webidl-conversions": 48
    }],
    43: [function (_dereq_, module, exports) {
      module.exports = {
        "IndexSizeError": 1,
        "DOMStringSizeError": 2,
        "HierarchyRequestError": 3,
        "WrongDocumentError": 4,
        "InvalidCharacterError": 5,
        "NoDataAllowedError": 6,
        "NoModificationAllowedError": 7,
        "NotFoundError": 8,
        "NotSupportedError": 9,
        "InUseAttributeError": 10,
        "InvalidStateError": 11,
        "SyntaxError": 12,
        "InvalidModificationError": 13,
        "NamespaceError": 14,
        "InvalidAccessError": 15,
        "ValidationError": 16,
        "TypeMismatchError": 17,
        "SecurityError": 18,
        "NetworkError": 19,
        "AbortError": 20,
        "URLMismatchError": 21,
        "QuotaExceededError": 22,
        "TimeoutError": 23,
        "InvalidNodeTypeError": 24,
        "DataCloneError": 25
      };
    }, {}],
    44: [function (_dereq_, module, exports) {
      "use strict";

      module.exports = _dereq_("./DOMException").interface;
      Object.setPrototypeOf(module.exports.prototype, Error.prototype);
    }, {
      "./DOMException": 42
    }],
    45: [function (_dereq_, module, exports) {
      "use strict"; // Returns "Type(value) is Object" in ES terminology.

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      function isObject(value) {
        return (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && value !== null || typeof value === "function";
      }

      function getReferenceToBytes(bufferSource) {
        // Node.js' Buffer does not allow subclassing for now, so we can get away with a prototype object check for perf.
        if (Object.getPrototypeOf(bufferSource) === Buffer.prototype) {
          return bufferSource;
        }

        if (bufferSource instanceof ArrayBuffer) {
          return Buffer.from(bufferSource);
        }

        return Buffer.from(bufferSource.buffer, bufferSource.byteOffset, bufferSource.byteLength);
      }

      function getCopyToBytes(bufferSource) {
        return Buffer.from(getReferenceToBytes(bufferSource));
      }

      function mixin(target, source) {
        var keys = Object.getOwnPropertyNames(source);

        for (var i = 0; i < keys.length; ++i) {
          if (keys[i] in target) {
            continue;
          }

          Object.defineProperty(target, keys[i], Object.getOwnPropertyDescriptor(source, keys[i]));
        }
      }

      var wrapperSymbol = Symbol("wrapper");
      var implSymbol = Symbol("impl");
      var sameObjectCaches = Symbol("SameObject caches");

      function getSameObject(wrapper, prop, creator) {
        if (!wrapper[sameObjectCaches]) {
          wrapper[sameObjectCaches] = Object.create(null);
        }

        if (prop in wrapper[sameObjectCaches]) {
          return wrapper[sameObjectCaches][prop];
        }

        wrapper[sameObjectCaches][prop] = creator();
        return wrapper[sameObjectCaches][prop];
      }

      function wrapperForImpl(impl) {
        return impl ? impl[wrapperSymbol] : null;
      }

      function implForWrapper(wrapper) {
        return wrapper ? wrapper[implSymbol] : null;
      }

      function tryWrapperForImpl(impl) {
        var wrapper = wrapperForImpl(impl);
        return wrapper ? wrapper : impl;
      }

      function tryImplForWrapper(wrapper) {
        var impl = implForWrapper(wrapper);
        return impl ? impl : wrapper;
      }

      var iterInternalSymbol = Symbol("internal");
      var IteratorPrototype = Object.getPrototypeOf(Object.getPrototypeOf([][Symbol.iterator]()));
      module.exports = exports = {
        isObject: isObject,
        getReferenceToBytes: getReferenceToBytes,
        getCopyToBytes: getCopyToBytes,
        mixin: mixin,
        wrapperSymbol: wrapperSymbol,
        implSymbol: implSymbol,
        getSameObject: getSameObject,
        wrapperForImpl: wrapperForImpl,
        implForWrapper: implForWrapper,
        tryWrapperForImpl: tryWrapperForImpl,
        tryImplForWrapper: tryImplForWrapper,
        iterInternalSymbol: iterInternalSymbol,
        IteratorPrototype: IteratorPrototype
      };
    }, {}],
    46: [function (_dereq_, module, exports) {
      "use strict";

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      !function (e, t) {
        "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.Typeson = e.Typeson || {}, e.Typeson.presets = e.Typeson.presets || {}, e.Typeson.presets.structuredCloningThrowing = t());
      }(undefined, function () {
        "use strict";

        var e = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
          return typeof e === "undefined" ? "undefined" : _typeof(e);
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
        },
            t = function () {
          return function (e, t) {
            if (Array.isArray(e)) return e;
            if (Symbol.iterator in Object(e)) return function sliceIterator(e, t) {
              var n = [],
                  r = !0,
                  i = !1,
                  o = void 0;

              try {
                for (var s, a = e[Symbol.iterator](); !(r = (s = a.next()).done) && (n.push(s.value), !t || n.length !== t); r = !0) {}
              } catch (e) {
                i = !0, o = e;
              } finally {
                try {
                  !r && a.return && a.return();
                } finally {
                  if (i) throw o;
                }
              }

              return n;
            }(e, t);
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          };
        }(),
            n = function n(e) {
          if (Array.isArray(e)) {
            for (var t = 0, n = Array(e.length); t < e.length; t++) {
              n[t] = e[t];
            }

            return n;
          }

          return Array.from(e);
        },
            r = Object.keys,
            i = Array.isArray,
            o = {}.toString,
            s = Object.getPrototypeOf,
            a = {}.hasOwnProperty,
            c = a.toString,
            u = ["type", "replaced", "iterateIn", "iterateUnsetNumeric"];

        function isThenable(e, t) {
          return Typeson.isObject(e) && "function" == typeof e.then && (!t || "function" == typeof e.catch);
        }

        function toStringTag(e) {
          return o.call(e).slice(8, -1);
        }

        function hasConstructorOf(t, n) {
          if (!t || "object" !== (void 0 === t ? "undefined" : e(t))) return !1;
          var r = s(t);
          if (!r) return !1;
          var i = a.call(r, "constructor") && r.constructor;
          return "function" != typeof i ? null === n : "function" == typeof i && null !== n && c.call(i) === c.call(n);
        }

        function isPlainObject(e) {
          return !(!e || "Object" !== toStringTag(e)) && (!s(e) || hasConstructorOf(e, Object));
        }

        function isObject(t) {
          return t && "object" === (void 0 === t ? "undefined" : e(t));
        }

        function Typeson(o) {
          var s = [],
              a = [],
              c = {},
              f = this.types = {},
              p = this.stringify = function (e, t, n, r) {
            r = Object.assign({}, o, r, {
              stringification: !0
            });
            var s = y(e, null, r);
            return i(s) ? JSON.stringify(s[0], t, n) : s.then(function (e) {
              return JSON.stringify(e, t, n);
            });
          };

          this.stringifySync = function (e, t, n, r) {
            return p(e, t, n, Object.assign({}, {
              throwOnBadSyncType: !0
            }, r, {
              sync: !0
            }));
          }, this.stringifyAsync = function (e, t, n, r) {
            return p(e, t, n, Object.assign({}, {
              throwOnBadSyncType: !0
            }, r, {
              sync: !1
            }));
          };

          var l = this.parse = function (e, t, n) {
            return n = Object.assign({}, o, n, {
              parse: !0
            }), v(JSON.parse(e, t), n);
          };

          this.parseSync = function (e, t, n) {
            return l(e, t, Object.assign({}, {
              throwOnBadSyncType: !0
            }, n, {
              sync: !0
            }));
          }, this.parseAsync = function (e, t, n) {
            return l(e, t, Object.assign({}, {
              throwOnBadSyncType: !0
            }, n, {
              sync: !1
            }));
          }, this.specialTypeNames = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return n.returnTypeNames = !0, this.encapsulate(e, t, n);
          }, this.rootTypeName = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            return n.iterateNone = !0, this.encapsulate(e, t, n);
          };

          var y = this.encapsulate = function (f, p, l) {
            var y = (l = Object.assign({
              sync: !0
            }, o, l)).sync,
                v = {},
                d = [],
                h = [],
                b = [],
                g = !(l && "cyclic" in l) || l.cyclic,
                m = l.encapsulateObserver,
                T = _encapsulate("", f, g, p || {}, b);

            function finish(e) {
              var t = Object.values(v);
              if (l.iterateNone) return t.length ? t[0] : Typeson.getJSONType(e);

              if (t.length) {
                if (l.returnTypeNames) return [].concat(n(new Set(t)));
                e && isPlainObject(e) && !e.hasOwnProperty("$types") ? e.$types = v : e = {
                  $: e,
                  $types: {
                    $: v
                  }
                };
              } else isObject(e) && e.hasOwnProperty("$types") && (e = {
                $: e,
                $types: !0
              });

              return !l.returnTypeNames && e;
            }

            return b.length ? y && l.throwOnBadSyncType ? function () {
              throw new TypeError("Sync method requested but async result obtained");
            }() : Promise.resolve(function checkPromises(e, n) {
              return Promise.all(n.map(function (e) {
                return e[1].p;
              })).then(function (r) {
                return Promise.all(r.map(function (r) {
                  var i = [],
                      o = n.splice(0, 1)[0],
                      s = t(o, 7),
                      a = s[0],
                      c = s[2],
                      u = s[3],
                      f = s[4],
                      p = s[5],
                      l = s[6],
                      y = _encapsulate(a, r, c, u, i, !0, l),
                      v = hasConstructorOf(y, TypesonPromise);

                  return a && v ? y.p.then(function (t) {
                    return f[p] = t, checkPromises(e, i);
                  }) : (a ? f[p] = y : e = v ? y.p : y, checkPromises(e, i));
                }));
              }).then(function () {
                return e;
              });
            }(T, b)).then(finish) : !y && l.throwOnBadSyncType ? function () {
              throw new TypeError("Async method requested but sync result obtained");
            }() : l.stringification && y ? [finish(T)] : y ? finish(T) : Promise.resolve(finish(T));

            function _adaptBuiltinStateObjectProperties(e, t, n) {
              Object.assign(e, t);
              var r = u.map(function (t) {
                var n = e[t];
                return delete e[t], n;
              });
              n(), u.forEach(function (t, n) {
                e[t] = r[n];
              });
            }

            function _encapsulate(t, n, o, a, c, u, f) {
              var p = void 0,
                  y = {},
                  b = void 0 === n ? "undefined" : e(n),
                  g = m ? function (e) {
                var r = f || a.type || Typeson.getJSONType(n);
                m(Object.assign(e || y, {
                  keypath: t,
                  value: n,
                  cyclic: o,
                  stateObj: a,
                  promisesData: c,
                  resolvingTypesonPromise: u,
                  awaitingTypesonPromise: hasConstructorOf(n, TypesonPromise)
                }, void 0 !== r ? {
                  type: r
                } : {}));
              } : null;
              if (b in {
                string: 1,
                boolean: 1,
                number: 1,
                undefined: 1
              }) return void 0 === n || "number" === b && (isNaN(n) || n === -1 / 0 || n === 1 / 0) ? (p = replace(t, n, a, c, !1, u, g)) !== n && (y = {
                replaced: p
              }) : p = n, g && g(), p;
              if (null === n) return g && g(), n;

              if (o && !a.iterateIn && !a.iterateUnsetNumeric) {
                var T = d.indexOf(n);
                if (!(T < 0)) return v[t] = "#", g && g({
                  cyclicKeypath: h[T]
                }), "#" + h[T];
                !0 === o && (d.push(n), h.push(t));
              }

              var O = isPlainObject(n),
                  w = i(n),
                  S = (O || w) && (!s.length || a.replaced) || a.iterateIn ? n : replace(t, n, a, c, O || w, null, g),
                  P = void 0;
              if (S !== n ? (p = S, y = {
                replaced: S
              }) : w || "array" === a.iterateIn ? (P = new Array(n.length), y = {
                clone: P
              }) : O || "object" === a.iterateIn ? y = {
                clone: P = {}
              } : "" === t && hasConstructorOf(n, TypesonPromise) ? (c.push([t, n, o, a, void 0, void 0, a.type]), p = n) : p = n, g && g(), l.iterateNone) return P || p;
              if (!P) return p;

              if (a.iterateIn) {
                var j = function _loop(e) {
                  var r = {
                    ownKeys: n.hasOwnProperty(e)
                  };

                  _adaptBuiltinStateObjectProperties(a, r, function () {
                    var r = t + (t ? "." : "") + escapeKeyPathComponent(e),
                        i = _encapsulate(r, n[e], !!o, a, c, u);

                    hasConstructorOf(i, TypesonPromise) ? c.push([r, i, !!o, a, P, e, a.type]) : void 0 !== i && (P[e] = i);
                  });
                };

                for (var A in n) {
                  j(A);
                }

                g && g({
                  endIterateIn: !0,
                  end: !0
                });
              } else r(n).forEach(function (e) {
                var r = t + (t ? "." : "") + escapeKeyPathComponent(e);

                _adaptBuiltinStateObjectProperties(a, {
                  ownKeys: !0
                }, function () {
                  var t = _encapsulate(r, n[e], !!o, a, c, u);

                  hasConstructorOf(t, TypesonPromise) ? c.push([r, t, !!o, a, P, e, a.type]) : void 0 !== t && (P[e] = t);
                });
              }), g && g({
                endIterateOwn: !0,
                end: !0
              });

              if (a.iterateUnsetNumeric) {
                for (var C = n.length, N = function _loop2(e) {
                  if (!(e in n)) {
                    var r = t + (t ? "." : "") + e;

                    _adaptBuiltinStateObjectProperties(a, {
                      ownKeys: !1
                    }, function () {
                      var t = _encapsulate(r, void 0, !!o, a, c, u);

                      hasConstructorOf(t, TypesonPromise) ? c.push([r, t, !!o, a, P, e, a.type]) : void 0 !== t && (P[e] = t);
                    });
                  }
                }, B = 0; B < C; B++) {
                  N(B);
                }

                g && g({
                  endIterateUnsetNumeric: !0,
                  end: !0
                });
              }

              return P;
            }

            function replace(e, t, n, r, i, o, u) {
              for (var f = i ? s : a, p = f.length; p--;) {
                var l = f[p];

                if (l.test(t, n)) {
                  var d = l.type;

                  if (c[d]) {
                    var h = v[e];
                    v[e] = h ? [d].concat(h) : d;
                  }

                  return Object.assign(n, {
                    type: d,
                    replaced: !0
                  }), !y && l.replaceAsync || l.replace ? (u && u({
                    replacing: !0
                  }), _encapsulate(e, l[y || !l.replaceAsync ? "replace" : "replaceAsync"](t, n), g && "readonly", n, r, o, d)) : (u && u({
                    typeDetected: !0
                  }), _encapsulate(e, t, g && "readonly", n, r, o, d));
                }
              }

              return t;
            }
          };

          this.encapsulateSync = function (e, t, n) {
            return y(e, t, Object.assign({}, {
              throwOnBadSyncType: !0
            }, n, {
              sync: !0
            }));
          }, this.encapsulateAsync = function (e, t, n) {
            return y(e, t, Object.assign({}, {
              throwOnBadSyncType: !0
            }, n, {
              sync: !1
            }));
          };

          var v = this.revive = function (e, n) {
            var s = (n = Object.assign({
              sync: !0
            }, o, n)).sync,
                a = e && e.$types,
                u = !0;
            if (!a) return e;
            if (!0 === a) return e.$;
            a.$ && isPlainObject(a.$) && (e = e.$, a = a.$, u = !1);

            var f = [],
                p = {},
                l = function _revive(e, n, o, s, l, y) {
              if (u && "$types" === e) return;
              var v = a[e];

              if (i(n) || isPlainObject(n)) {
                var d = i(n) ? new Array(n.length) : {};

                for (r(n).forEach(function (t) {
                  var r = _revive(e + (e ? "." : "") + escapeKeyPathComponent(t), n[t], o || d, s, d, t);

                  hasConstructorOf(r, Undefined) ? d[t] = void 0 : void 0 !== r && (d[t] = r);
                }), n = d; f.length;) {
                  var h = t(f[0], 4),
                      b = h[0],
                      g = h[1],
                      m = h[2],
                      T = h[3],
                      O = getByKeyPath(b, g);
                  if (hasConstructorOf(O, Undefined)) m[T] = void 0;else {
                    if (void 0 === O) break;
                    m[T] = O;
                  }
                  f.splice(0, 1);
                }
              }

              if (!v) return n;

              if ("#" === v) {
                var w = getByKeyPath(o, n.substr(1));
                return void 0 === w && f.push([o, n.substr(1), l, y]), w;
              }

              var S = s.sync;
              return [].concat(v).reduce(function (e, t) {
                var n = c[t];
                if (!n) throw new Error("Unregistered type: " + t);
                return n[S && n.revive ? "revive" : !S && n.reviveAsync ? "reviveAsync" : "revive"](e, p);
              }, n);
            }("", e, null, n);

            return isThenable(l = hasConstructorOf(l, Undefined) ? void 0 : l) ? s && n.throwOnBadSyncType ? function () {
              throw new TypeError("Sync method requested but async result obtained");
            }() : l : !s && n.throwOnBadSyncType ? function () {
              throw new TypeError("Async method requested but sync result obtained");
            }() : s ? l : Promise.resolve(l);
          };

          this.reviveSync = function (e, t) {
            return v(e, Object.assign({}, {
              throwOnBadSyncType: !0
            }, t, {
              sync: !0
            }));
          }, this.reviveAsync = function (e, t) {
            return v(e, Object.assign({}, {
              throwOnBadSyncType: !0
            }, t, {
              sync: !1
            }));
          }, this.register = function (e, t) {
            return t = t || {}, [].concat(e).forEach(function R(e) {
              if (i(e)) return e.map(R);
              e && r(e).forEach(function (n) {
                if ("#" === n) throw new TypeError("# cannot be used as a type name as it is reserved for cyclic objects");
                if (Typeson.JSON_TYPES.includes(n)) throw new TypeError("Plain JSON object types are reserved as type names");
                var r = e[n],
                    o = r.testPlainObjects ? s : a,
                    u = o.filter(function (e) {
                  return e.type === n;
                });

                if (u.length && (o.splice(o.indexOf(u[0]), 1), delete c[n], delete f[n]), r) {
                  if ("function" == typeof r) {
                    var p = r;
                    r = {
                      test: function test(e) {
                        return e && e.constructor === p;
                      },
                      replace: function replace(e) {
                        return assign({}, e);
                      },
                      revive: function revive(e) {
                        return assign(Object.create(p.prototype), e);
                      }
                    };
                  } else i(r) && (r = {
                    test: r[0],
                    replace: r[1],
                    revive: r[2]
                  });

                  var l = {
                    type: n,
                    test: r.test.bind(r)
                  };
                  r.replace && (l.replace = r.replace.bind(r)), r.replaceAsync && (l.replaceAsync = r.replaceAsync.bind(r));
                  var y = "number" == typeof t.fallback ? t.fallback : t.fallback ? 0 : 1 / 0;

                  if (r.testPlainObjects ? s.splice(y, 0, l) : a.splice(y, 0, l), r.revive || r.reviveAsync) {
                    var v = {};
                    r.revive && (v.revive = r.revive.bind(r)), r.reviveAsync && (v.reviveAsync = r.reviveAsync.bind(r)), c[n] = v;
                  }

                  f[n] = r;
                }
              });
            }), this;
          };
        }

        function assign(e, t) {
          return r(t).map(function (n) {
            e[n] = t[n];
          }), e;
        }

        function escapeKeyPathComponent(e) {
          return e.replace(/~/g, "~0").replace(/\./g, "~1");
        }

        function unescapeKeyPathComponent(e) {
          return e.replace(/~1/g, ".").replace(/~0/g, "~");
        }

        function getByKeyPath(e, t) {
          if ("" === t) return e;
          var n = t.indexOf(".");

          if (n > -1) {
            var r = e[unescapeKeyPathComponent(t.substr(0, n))];
            return void 0 === r ? void 0 : getByKeyPath(r, t.substr(n + 1));
          }

          return e[unescapeKeyPathComponent(t)];
        }

        function Undefined() {}

        function TypesonPromise(e) {
          this.p = new Promise(e);
        }

        TypesonPromise.prototype.then = function (e, t) {
          var n = this;
          return new TypesonPromise(function (r, i) {
            n.p.then(function (t) {
              r(e ? e(t) : t);
            }, function (e) {
              n.p.catch(function (e) {
                return t ? t(e) : Promise.reject(e);
              }).then(r, i);
            });
          });
        }, TypesonPromise.prototype.catch = function (e) {
          return this.then(null, e);
        }, TypesonPromise.resolve = function (e) {
          return new TypesonPromise(function (t) {
            t(e);
          });
        }, TypesonPromise.reject = function (e) {
          return new TypesonPromise(function (t, n) {
            n(e);
          });
        }, ["all", "race"].map(function (e) {
          TypesonPromise[e] = function (t) {
            return new TypesonPromise(function (n, r) {
              Promise[e](t.map(function (e) {
                return e.p;
              })).then(n, r);
            });
          };
        }), Typeson.Undefined = Undefined, Typeson.Promise = TypesonPromise, Typeson.isThenable = isThenable, Typeson.toStringTag = toStringTag, Typeson.hasConstructorOf = hasConstructorOf, Typeson.isObject = isObject, Typeson.isPlainObject = isPlainObject, Typeson.isUserObject = function isUserObject(e) {
          if (!e || "Object" !== toStringTag(e)) return !1;
          var t = s(e);
          return !t || hasConstructorOf(e, Object) || isUserObject(t);
        }, Typeson.escapeKeyPathComponent = escapeKeyPathComponent, Typeson.unescapeKeyPathComponent = unescapeKeyPathComponent, Typeson.getByKeyPath = getByKeyPath, Typeson.getJSONType = function (t) {
          return null === t ? "null" : i(t) ? "array" : void 0 === t ? "undefined" : e(t);
        }, Typeson.JSON_TYPES = ["null", "boolean", "number", "string", "array", "object"];

        for (var f = {
          userObject: {
            test: function test(e, t) {
              return Typeson.isUserObject(e);
            },
            replace: function replace(e) {
              return Object.assign({}, e);
            },
            revive: function revive(e) {
              return e;
            }
          }
        }, p = [[{
          sparseArrays: {
            testPlainObjects: !0,
            test: function test(e) {
              return Array.isArray(e);
            },
            replace: function replace(e, t) {
              return t.iterateUnsetNumeric = !0, e;
            }
          }
        }, {
          sparseUndefined: {
            test: function test(e, t) {
              return void 0 === e && !1 === t.ownKeys;
            },
            replace: function replace(e) {
              return null;
            },
            revive: function revive(e) {}
          }
        }], {
          undef: {
            test: function test(e, t) {
              return void 0 === e && (t.ownKeys || !("ownKeys" in t));
            },
            replace: function replace(e) {
              return null;
            },
            revive: function revive(e) {
              return new Typeson.Undefined();
            }
          }
        }], l = {
          StringObject: {
            test: function test(t) {
              return "String" === Typeson.toStringTag(t) && "object" === (void 0 === t ? "undefined" : e(t));
            },
            replace: function replace(e) {
              return String(e);
            },
            revive: function revive(e) {
              return new String(e);
            }
          },
          BooleanObject: {
            test: function test(t) {
              return "Boolean" === Typeson.toStringTag(t) && "object" === (void 0 === t ? "undefined" : e(t));
            },
            replace: function replace(e) {
              return Boolean(e);
            },
            revive: function revive(e) {
              return new Boolean(e);
            }
          },
          NumberObject: {
            test: function test(t) {
              return "Number" === Typeson.toStringTag(t) && "object" === (void 0 === t ? "undefined" : e(t));
            },
            replace: function replace(e) {
              return Number(e);
            },
            revive: function revive(e) {
              return new Number(e);
            }
          }
        }, y = [{
          nan: {
            test: function test(e) {
              return "number" == typeof e && isNaN(e);
            },
            replace: function replace(e) {
              return "NaN";
            },
            revive: function revive(e) {
              return NaN;
            }
          }
        }, {
          infinity: {
            test: function test(e) {
              return e === 1 / 0;
            },
            replace: function replace(e) {
              return "Infinity";
            },
            revive: function revive(e) {
              return 1 / 0;
            }
          }
        }, {
          negativeInfinity: {
            test: function test(e) {
              return e === -1 / 0;
            },
            replace: function replace(e) {
              return "-Infinity";
            },
            revive: function revive(e) {
              return -1 / 0;
            }
          }
        }], v = {
          date: {
            test: function test(e) {
              return "Date" === Typeson.toStringTag(e);
            },
            replace: function replace(e) {
              var t = e.getTime();
              return isNaN(t) ? "NaN" : t;
            },
            revive: function revive(e) {
              return "NaN" === e ? new Date(NaN) : new Date(e);
            }
          }
        }, d = {
          regexp: {
            test: function test(e) {
              return "RegExp" === Typeson.toStringTag(e);
            },
            replace: function replace(e) {
              return {
                source: e.source,
                flags: (e.global ? "g" : "") + (e.ignoreCase ? "i" : "") + (e.multiline ? "m" : "") + (e.sticky ? "y" : "") + (e.unicode ? "u" : "")
              };
            },
            revive: function revive(e) {
              var t = e.source,
                  n = e.flags;
              return new RegExp(t, n);
            }
          }
        }, h = {
          map: {
            test: function test(e) {
              return "Map" === Typeson.toStringTag(e);
            },
            replace: function replace(e) {
              return Array.from(e.entries());
            },
            revive: function revive(e) {
              return new Map(e);
            }
          }
        }, b = {
          set: {
            test: function test(e) {
              return "Set" === Typeson.toStringTag(e);
            },
            replace: function replace(e) {
              return Array.from(e.values());
            },
            revive: function revive(e) {
              return new Set(e);
            }
          }
        }, g = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", m = new Uint8Array(256), T = 0; T < g.length; T++) {
          m[g.charCodeAt(T)] = T;
        }

        var O = function encode(e, t, n) {
          for (var r = new Uint8Array(e, t, n), i = r.length, o = "", s = 0; s < i; s += 3) {
            o += g[r[s] >> 2], o += g[(3 & r[s]) << 4 | r[s + 1] >> 4], o += g[(15 & r[s + 1]) << 2 | r[s + 2] >> 6], o += g[63 & r[s + 2]];
          }

          return i % 3 == 2 ? o = o.substring(0, o.length - 1) + "=" : i % 3 == 1 && (o = o.substring(0, o.length - 2) + "=="), o;
        },
            w = function decode(e) {
          var t = e.length,
              n = .75 * e.length,
              r = 0,
              i = void 0,
              o = void 0,
              s = void 0,
              a = void 0;
          "=" === e[e.length - 1] && (n--, "=" === e[e.length - 2] && n--);

          for (var c = new ArrayBuffer(n), u = new Uint8Array(c), f = 0; f < t; f += 4) {
            i = m[e.charCodeAt(f)], o = m[e.charCodeAt(f + 1)], s = m[e.charCodeAt(f + 2)], a = m[e.charCodeAt(f + 3)], u[r++] = i << 2 | o >> 4, u[r++] = (15 & o) << 4 | s >> 2, u[r++] = (3 & s) << 6 | 63 & a;
          }

          return c;
        },
            S = {
          arraybuffer: {
            test: function test(e) {
              return "ArrayBuffer" === Typeson.toStringTag(e);
            },
            replace: function replace(e, t) {
              t.buffers || (t.buffers = []);
              var n = t.buffers.indexOf(e);
              return n > -1 ? {
                index: n
              } : (t.buffers.push(e), O(e));
            },
            revive: function revive(t, n) {
              if (n.buffers || (n.buffers = []), "object" === (void 0 === t ? "undefined" : e(t))) return n.buffers[t.index];
              var r = w(t);
              return n.buffers.push(r), r;
            }
          }
        },
            P = "undefined" == typeof self ? global : self,
            j = {};

        ["Int8Array", "Uint8Array", "Uint8ClampedArray", "Int16Array", "Uint16Array", "Int32Array", "Uint32Array", "Float32Array", "Float64Array"].forEach(function (e) {
          var t = e,
              n = P[t];
          n && (j[e.toLowerCase()] = {
            test: function test(e) {
              return Typeson.toStringTag(e) === t;
            },
            replace: function replace(e, t) {
              var n = e.buffer,
                  r = e.byteOffset,
                  i = e.length;
              t.buffers || (t.buffers = []);
              var o = t.buffers.indexOf(n);
              return o > -1 ? {
                index: o,
                byteOffset: r,
                length: i
              } : (t.buffers.push(n), {
                encoded: O(n),
                byteOffset: r,
                length: i
              });
            },
            revive: function revive(e, t) {
              t.buffers || (t.buffers = []);
              var r = e.byteOffset,
                  i = e.length,
                  o = e.encoded,
                  s = e.index,
                  a = void 0;
              return "index" in e ? a = t.buffers[s] : (a = w(o), t.buffers.push(a)), new n(a, r, i);
            }
          });
        });
        var A = {
          dataview: {
            test: function test(e) {
              return "DataView" === Typeson.toStringTag(e);
            },
            replace: function replace(e, t) {
              var n = e.buffer,
                  r = e.byteOffset,
                  i = e.byteLength;
              t.buffers || (t.buffers = []);
              var o = t.buffers.indexOf(n);
              return o > -1 ? {
                index: o,
                byteOffset: r,
                byteLength: i
              } : (t.buffers.push(n), {
                encoded: O(n),
                byteOffset: r,
                byteLength: i
              });
            },
            revive: function revive(e, t) {
              t.buffers || (t.buffers = []);
              var n = e.byteOffset,
                  r = e.byteLength,
                  i = e.encoded,
                  o = e.index,
                  s = void 0;
              return "index" in e ? s = t.buffers[o] : (s = w(i), t.buffers.push(s)), new DataView(s, n, r);
            }
          }
        },
            C = {
          IntlCollator: {
            test: function test(e) {
              return Typeson.hasConstructorOf(e, Intl.Collator);
            },
            replace: function replace(e) {
              return e.resolvedOptions();
            },
            revive: function revive(e) {
              return new Intl.Collator(e.locale, e);
            }
          },
          IntlDateTimeFormat: {
            test: function test(e) {
              return Typeson.hasConstructorOf(e, Intl.DateTimeFormat);
            },
            replace: function replace(e) {
              return e.resolvedOptions();
            },
            revive: function revive(e) {
              return new Intl.DateTimeFormat(e.locale, e);
            }
          },
          IntlNumberFormat: {
            test: function test(e) {
              return Typeson.hasConstructorOf(e, Intl.NumberFormat);
            },
            replace: function replace(e) {
              return e.resolvedOptions();
            },
            revive: function revive(e) {
              return new Intl.NumberFormat(e.locale, e);
            }
          }
        },
            N = {
          file: {
            test: function test(e) {
              return "File" === Typeson.toStringTag(e);
            },
            replace: function replace(e) {
              var t = new XMLHttpRequest();
              if (t.open("GET", URL.createObjectURL(e), !1), 200 !== t.status && 0 !== t.status) throw new Error("Bad Blob access: " + t.status);
              return t.send(), {
                type: e.type,
                stringContents: t.responseText,
                name: e.name,
                lastModified: e.lastModified
              };
            },
            revive: function revive(e) {
              var t = e.name,
                  n = e.type,
                  r = e.stringContents,
                  i = e.lastModified;
              return new File([r], t, {
                type: n,
                lastModified: i
              });
            },
            replaceAsync: function replaceAsync(e) {
              return new Typeson.Promise(function (t, n) {
                if (e.isClosed) n(new Error("The File is closed"));else {
                  var r = new FileReader();
                  r.addEventListener("load", function () {
                    t({
                      type: e.type,
                      stringContents: r.result,
                      name: e.name,
                      lastModified: e.lastModified
                    });
                  }), r.addEventListener("error", function () {
                    n(r.error);
                  }), r.readAsText(e);
                }
              });
            }
          }
        };
        return [f, p, l, y, v, d, {
          imagedata: {
            test: function test(e) {
              return "ImageData" === Typeson.toStringTag(e);
            },
            replace: function replace(e) {
              return {
                array: Array.from(e.data),
                width: e.width,
                height: e.height
              };
            },
            revive: function revive(e) {
              return new ImageData(new Uint8ClampedArray(e.array), e.width, e.height);
            }
          }
        }, {
          imagebitmap: {
            test: function test(e) {
              return "ImageBitmap" === Typeson.toStringTag(e) || e && e.dataset && "ImageBitmap" === e.dataset.toStringTag;
            },
            replace: function replace(e) {
              var t = document.createElement("canvas");
              return t.getContext("2d").drawImage(e, 0, 0), t.toDataURL();
            },
            revive: function revive(e) {
              var t = document.createElement("canvas"),
                  n = t.getContext("2d"),
                  r = document.createElement("img");
              return r.onload = function () {
                n.drawImage(r, 0, 0);
              }, r.src = e, t;
            },
            reviveAsync: function reviveAsync(e) {
              var t = document.createElement("canvas"),
                  n = t.getContext("2d"),
                  r = document.createElement("img");
              return r.onload = function () {
                n.drawImage(r, 0, 0);
              }, r.src = e, createImageBitmap(t);
            }
          }
        }, N, {
          file: N.file,
          filelist: {
            test: function test(e) {
              return "FileList" === Typeson.toStringTag(e);
            },
            replace: function replace(e) {
              for (var t = [], n = 0; n < e.length; n++) {
                t[n] = e.item(n);
              }

              return t;
            },
            revive: function revive(e) {
              function FileList() {
                this._files = arguments[0], this.length = this._files.length;
              }

              return FileList.prototype.item = function (e) {
                return this._files[e];
              }, FileList.prototype[Symbol.toStringTag] = "FileList", new FileList(e);
            }
          }
        }, {
          blob: {
            test: function test(e) {
              return "Blob" === Typeson.toStringTag(e);
            },
            replace: function replace(e) {
              var t = new XMLHttpRequest();
              if (t.open("GET", URL.createObjectURL(e), !1), 200 !== t.status && 0 !== t.status) throw new Error("Bad Blob access: " + t.status);
              return t.send(), {
                type: e.type,
                stringContents: t.responseText
              };
            },
            revive: function revive(e) {
              var t = e.type,
                  n = e.stringContents;
              return new Blob([n], {
                type: t
              });
            },
            replaceAsync: function replaceAsync(e) {
              return new Typeson.Promise(function (t, n) {
                if (e.isClosed) n(new Error("The Blob is closed"));else {
                  var r = new FileReader();
                  r.addEventListener("load", function () {
                    t({
                      type: e.type,
                      stringContents: r.result
                    });
                  }), r.addEventListener("error", function () {
                    n(r.error);
                  }), r.readAsText(e);
                }
              });
            }
          }
        }].concat("function" == typeof Map ? h : [], "function" == typeof Set ? b : [], "function" == typeof ArrayBuffer ? S : [], "function" == typeof Uint8Array ? j : [], "function" == typeof DataView ? A : [], "undefined" != typeof Intl ? C : []).concat({
          checkDataCloneException: [function (t) {
            var n = {}.toString.call(t).slice(8, -1);
            if (["symbol", "function"].includes(void 0 === t ? "undefined" : e(t)) || ["Arguments", "Module", "Error", "Promise", "WeakMap", "WeakSet"].includes(n) || t === Object.prototype || ("Blob" === n || "File" === n) && t.isClosed || t && "object" === (void 0 === t ? "undefined" : e(t)) && "number" == typeof t.nodeType && "function" == typeof t.insertBefore) throw new DOMException("The object cannot be cloned.", "DataCloneError");
            return !1;
          }]
        });
      });
    }, {}],
    47: [function (_dereq_, module, exports) {
      "use strict";

      var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      var _typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (e) {
        return typeof e === "undefined" ? "undefined" : _typeof2(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof2(e);
      },
          slicedToArray = function () {
        return function (e, n) {
          if (Array.isArray(e)) return e;
          if (Symbol.iterator in Object(e)) return function sliceIterator(e, n) {
            var t = [],
                r = !0,
                i = !1,
                o = void 0;

            try {
              for (var s, a = e[Symbol.iterator](); !(r = (s = a.next()).done) && (t.push(s.value), !n || t.length !== n); r = !0) {}
            } catch (e) {
              i = !0, o = e;
            } finally {
              try {
                !r && a.return && a.return();
              } finally {
                if (i) throw o;
              }
            }

            return t;
          }(e, n);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }(),
          toConsumableArray = function toConsumableArray(e) {
        if (Array.isArray(e)) {
          for (var n = 0, t = Array(e.length); n < e.length; n++) {
            t[n] = e[n];
          }

          return t;
        }

        return Array.from(e);
      },
          keys = Object.keys,
          isArray = Array.isArray,
          toString = {}.toString,
          getProto = Object.getPrototypeOf,
          hasOwn = {}.hasOwnProperty,
          fnToString = hasOwn.toString,
          internalStateObjPropsToIgnore = ["type", "replaced", "iterateIn", "iterateUnsetNumeric"];

      function isThenable(e, n) {
        return Typeson.isObject(e) && "function" == typeof e.then && (!n || "function" == typeof e.catch);
      }

      function toStringTag(e) {
        return toString.call(e).slice(8, -1);
      }

      function hasConstructorOf(e, n) {
        if (!e || "object" !== (void 0 === e ? "undefined" : _typeof(e))) return !1;
        var t = getProto(e);
        if (!t) return !1;
        var r = hasOwn.call(t, "constructor") && t.constructor;
        return "function" != typeof r ? null === n : "function" == typeof r && null !== n && fnToString.call(r) === fnToString.call(n);
      }

      function isPlainObject(e) {
        return !(!e || "Object" !== toStringTag(e)) && (!getProto(e) || hasConstructorOf(e, Object));
      }

      function isUserObject(e) {
        if (!e || "Object" !== toStringTag(e)) return !1;
        var n = getProto(e);
        return !n || hasConstructorOf(e, Object) || isUserObject(n);
      }

      function isObject(e) {
        return e && "object" === (void 0 === e ? "undefined" : _typeof(e));
      }

      function Typeson(e) {
        var n = [],
            t = [],
            r = {},
            i = this.types = {},
            o = this.stringify = function (n, t, r, i) {
          i = Object.assign({}, e, i, {
            stringification: !0
          });
          var o = a(n, null, i);
          return isArray(o) ? JSON.stringify(o[0], t, r) : o.then(function (e) {
            return JSON.stringify(e, t, r);
          });
        };

        this.stringifySync = function (e, n, t, r) {
          return o(e, n, t, Object.assign({}, {
            throwOnBadSyncType: !0
          }, r, {
            sync: !0
          }));
        }, this.stringifyAsync = function (e, n, t, r) {
          return o(e, n, t, Object.assign({}, {
            throwOnBadSyncType: !0
          }, r, {
            sync: !1
          }));
        };

        var s = this.parse = function (n, t, r) {
          return r = Object.assign({}, e, r, {
            parse: !0
          }), c(JSON.parse(n, t), r);
        };

        this.parseSync = function (e, n, t) {
          return s(e, n, Object.assign({}, {
            throwOnBadSyncType: !0
          }, t, {
            sync: !0
          }));
        }, this.parseAsync = function (e, n, t) {
          return s(e, n, Object.assign({}, {
            throwOnBadSyncType: !0
          }, t, {
            sync: !1
          }));
        }, this.specialTypeNames = function (e, n) {
          var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return t.returnTypeNames = !0, this.encapsulate(e, n, t);
        }, this.rootTypeName = function (e, n) {
          var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return t.iterateNone = !0, this.encapsulate(e, n, t);
        };

        var a = this.encapsulate = function (i, o, s) {
          var a = (s = Object.assign({
            sync: !0
          }, e, s)).sync,
              c = {},
              u = [],
              y = [],
              p = [],
              f = !(s && "cyclic" in s) || s.cyclic,
              l = s.encapsulateObserver,
              h = _encapsulate("", i, f, o || {}, p);

          function finish(e) {
            var n = Object.values(c);
            if (s.iterateNone) return n.length ? n[0] : Typeson.getJSONType(e);

            if (n.length) {
              if (s.returnTypeNames) return [].concat(toConsumableArray(new Set(n)));
              e && isPlainObject(e) && !e.hasOwnProperty("$types") ? e.$types = c : e = {
                $: e,
                $types: {
                  $: c
                }
              };
            } else isObject(e) && e.hasOwnProperty("$types") && (e = {
              $: e,
              $types: !0
            });

            return !s.returnTypeNames && e;
          }

          return p.length ? a && s.throwOnBadSyncType ? function () {
            throw new TypeError("Sync method requested but async result obtained");
          }() : Promise.resolve(function checkPromises(e, n) {
            return Promise.all(n.map(function (e) {
              return e[1].p;
            })).then(function (t) {
              return Promise.all(t.map(function (t) {
                var r = [],
                    i = n.splice(0, 1)[0],
                    o = slicedToArray(i, 7),
                    s = o[0],
                    a = o[2],
                    c = o[3],
                    u = o[4],
                    y = o[5],
                    p = o[6],
                    f = _encapsulate(s, t, a, c, r, !0, p),
                    l = hasConstructorOf(f, TypesonPromise);

                return s && l ? f.p.then(function (n) {
                  return u[y] = n, checkPromises(e, r);
                }) : (s ? u[y] = f : e = l ? f.p : f, checkPromises(e, r));
              }));
            }).then(function () {
              return e;
            });
          }(h, p)).then(finish) : !a && s.throwOnBadSyncType ? function () {
            throw new TypeError("Async method requested but sync result obtained");
          }() : s.stringification && a ? [finish(h)] : a ? finish(h) : Promise.resolve(finish(h));

          function _adaptBuiltinStateObjectProperties(e, n, t) {
            Object.assign(e, n);
            var r = internalStateObjPropsToIgnore.map(function (n) {
              var t = e[n];
              return delete e[n], t;
            });
            t(), internalStateObjPropsToIgnore.forEach(function (n, t) {
              e[n] = r[t];
            });
          }

          function _encapsulate(e, t, r, i, o, a, p) {
            var f = void 0,
                h = {},
                v = void 0 === t ? "undefined" : _typeof(t),
                d = l ? function (n) {
              var s = p || i.type || Typeson.getJSONType(t);
              l(Object.assign(n || h, {
                keypath: e,
                value: t,
                cyclic: r,
                stateObj: i,
                promisesData: o,
                resolvingTypesonPromise: a,
                awaitingTypesonPromise: hasConstructorOf(t, TypesonPromise)
              }, void 0 !== s ? {
                type: s
              } : {}));
            } : null;
            if (v in {
              string: 1,
              boolean: 1,
              number: 1,
              undefined: 1
            }) return void 0 === t || "number" === v && (isNaN(t) || t === -1 / 0 || t === 1 / 0) ? (f = replace(e, t, i, o, !1, a, d)) !== t && (h = {
              replaced: f
            }) : f = t, d && d(), f;
            if (null === t) return d && d(), t;

            if (r && !i.iterateIn && !i.iterateUnsetNumeric) {
              var b = u.indexOf(t);
              if (!(b < 0)) return c[e] = "#", d && d({
                cyclicKeypath: y[b]
              }), "#" + y[b];
              !0 === r && (u.push(t), y.push(e));
            }

            var O = isPlainObject(t),
                g = isArray(t),
                T = (O || g) && (!n.length || i.replaced) || i.iterateIn ? t : replace(e, t, i, o, O || g, null, d),
                m = void 0;
            if (T !== t ? (f = T, h = {
              replaced: T
            }) : g || "array" === i.iterateIn ? (m = new Array(t.length), h = {
              clone: m
            }) : O || "object" === i.iterateIn ? h = {
              clone: m = {}
            } : "" === e && hasConstructorOf(t, TypesonPromise) ? (o.push([e, t, r, i, void 0, void 0, i.type]), f = t) : f = t, d && d(), s.iterateNone) return m || f;
            if (!m) return f;

            if (i.iterateIn) {
              var P = function _loop(n) {
                var s = {
                  ownKeys: t.hasOwnProperty(n)
                };

                _adaptBuiltinStateObjectProperties(i, s, function () {
                  var s = e + (e ? "." : "") + escapeKeyPathComponent(n),
                      c = _encapsulate(s, t[n], !!r, i, o, a);

                  hasConstructorOf(c, TypesonPromise) ? o.push([s, c, !!r, i, m, n, i.type]) : void 0 !== c && (m[n] = c);
                });
              };

              for (var j in t) {
                P(j);
              }

              d && d({
                endIterateIn: !0,
                end: !0
              });
            } else keys(t).forEach(function (n) {
              var s = e + (e ? "." : "") + escapeKeyPathComponent(n);

              _adaptBuiltinStateObjectProperties(i, {
                ownKeys: !0
              }, function () {
                var e = _encapsulate(s, t[n], !!r, i, o, a);

                hasConstructorOf(e, TypesonPromise) ? o.push([s, e, !!r, i, m, n, i.type]) : void 0 !== e && (m[n] = e);
              });
            }), d && d({
              endIterateOwn: !0,
              end: !0
            });

            if (i.iterateUnsetNumeric) {
              for (var S = t.length, w = function _loop2(n) {
                if (!(n in t)) {
                  var s = e + (e ? "." : "") + n;

                  _adaptBuiltinStateObjectProperties(i, {
                    ownKeys: !1
                  }, function () {
                    var e = _encapsulate(s, void 0, !!r, i, o, a);

                    hasConstructorOf(e, TypesonPromise) ? o.push([s, e, !!r, i, m, n, i.type]) : void 0 !== e && (m[n] = e);
                  });
                }
              }, A = 0; A < S; A++) {
                w(A);
              }

              d && d({
                endIterateUnsetNumeric: !0,
                end: !0
              });
            }

            return m;
          }

          function replace(e, i, o, s, u, y, p) {
            for (var l = u ? n : t, h = l.length; h--;) {
              var v = l[h];

              if (v.test(i, o)) {
                var d = v.type;

                if (r[d]) {
                  var b = c[e];
                  c[e] = b ? [d].concat(b) : d;
                }

                return Object.assign(o, {
                  type: d,
                  replaced: !0
                }), !a && v.replaceAsync || v.replace ? (p && p({
                  replacing: !0
                }), _encapsulate(e, v[a || !v.replaceAsync ? "replace" : "replaceAsync"](i, o), f && "readonly", o, s, y, d)) : (p && p({
                  typeDetected: !0
                }), _encapsulate(e, i, f && "readonly", o, s, y, d));
              }
            }

            return i;
          }
        };

        this.encapsulateSync = function (e, n, t) {
          return a(e, n, Object.assign({}, {
            throwOnBadSyncType: !0
          }, t, {
            sync: !0
          }));
        }, this.encapsulateAsync = function (e, n, t) {
          return a(e, n, Object.assign({}, {
            throwOnBadSyncType: !0
          }, t, {
            sync: !1
          }));
        };

        var c = this.revive = function (n, t) {
          var i = (t = Object.assign({
            sync: !0
          }, e, t)).sync,
              o = n && n.$types,
              s = !0;
          if (!o) return n;
          if (!0 === o) return n.$;
          o.$ && isPlainObject(o.$) && (n = n.$, o = o.$, s = !1);

          var a = [],
              c = {},
              u = function _revive(e, n, t, i, u, y) {
            if (s && "$types" === e) return;
            var p = o[e];

            if (isArray(n) || isPlainObject(n)) {
              var f = isArray(n) ? new Array(n.length) : {};

              for (keys(n).forEach(function (r) {
                var o = _revive(e + (e ? "." : "") + escapeKeyPathComponent(r), n[r], t || f, i, f, r);

                hasConstructorOf(o, Undefined) ? f[r] = void 0 : void 0 !== o && (f[r] = o);
              }), n = f; a.length;) {
                var l = slicedToArray(a[0], 4),
                    h = l[0],
                    v = l[1],
                    d = l[2],
                    b = l[3],
                    O = getByKeyPath(h, v);
                if (hasConstructorOf(O, Undefined)) d[b] = void 0;else {
                  if (void 0 === O) break;
                  d[b] = O;
                }
                a.splice(0, 1);
              }
            }

            if (!p) return n;

            if ("#" === p) {
              var g = getByKeyPath(t, n.substr(1));
              return void 0 === g && a.push([t, n.substr(1), u, y]), g;
            }

            var T = i.sync;
            return [].concat(p).reduce(function (e, n) {
              var t = r[n];
              if (!t) throw new Error("Unregistered type: " + n);
              return t[T && t.revive ? "revive" : !T && t.reviveAsync ? "reviveAsync" : "revive"](e, c);
            }, n);
          }("", n, null, t);

          return isThenable(u = hasConstructorOf(u, Undefined) ? void 0 : u) ? i && t.throwOnBadSyncType ? function () {
            throw new TypeError("Sync method requested but async result obtained");
          }() : u : !i && t.throwOnBadSyncType ? function () {
            throw new TypeError("Async method requested but sync result obtained");
          }() : i ? u : Promise.resolve(u);
        };

        this.reviveSync = function (e, n) {
          return c(e, Object.assign({}, {
            throwOnBadSyncType: !0
          }, n, {
            sync: !0
          }));
        }, this.reviveAsync = function (e, n) {
          return c(e, Object.assign({}, {
            throwOnBadSyncType: !0
          }, n, {
            sync: !1
          }));
        }, this.register = function (e, o) {
          return o = o || {}, [].concat(e).forEach(function R(e) {
            if (isArray(e)) return e.map(R);
            e && keys(e).forEach(function (s) {
              if ("#" === s) throw new TypeError("# cannot be used as a type name as it is reserved for cyclic objects");
              if (Typeson.JSON_TYPES.includes(s)) throw new TypeError("Plain JSON object types are reserved as type names");
              var a = e[s],
                  c = a.testPlainObjects ? n : t,
                  u = c.filter(function (e) {
                return e.type === s;
              });

              if (u.length && (c.splice(c.indexOf(u[0]), 1), delete r[s], delete i[s]), a) {
                if ("function" == typeof a) {
                  var y = a;
                  a = {
                    test: function test(e) {
                      return e && e.constructor === y;
                    },
                    replace: function replace(e) {
                      return assign({}, e);
                    },
                    revive: function revive(e) {
                      return assign(Object.create(y.prototype), e);
                    }
                  };
                } else isArray(a) && (a = {
                  test: a[0],
                  replace: a[1],
                  revive: a[2]
                });

                var p = {
                  type: s,
                  test: a.test.bind(a)
                };
                a.replace && (p.replace = a.replace.bind(a)), a.replaceAsync && (p.replaceAsync = a.replaceAsync.bind(a));
                var f = "number" == typeof o.fallback ? o.fallback : o.fallback ? 0 : 1 / 0;

                if (a.testPlainObjects ? n.splice(f, 0, p) : t.splice(f, 0, p), a.revive || a.reviveAsync) {
                  var l = {};
                  a.revive && (l.revive = a.revive.bind(a)), a.reviveAsync && (l.reviveAsync = a.reviveAsync.bind(a)), r[s] = l;
                }

                i[s] = a;
              }
            });
          }), this;
        };
      }

      function assign(e, n) {
        return keys(n).map(function (t) {
          e[t] = n[t];
        }), e;
      }

      function escapeKeyPathComponent(e) {
        return e.replace(/~/g, "~0").replace(/\./g, "~1");
      }

      function unescapeKeyPathComponent(e) {
        return e.replace(/~1/g, ".").replace(/~0/g, "~");
      }

      function getByKeyPath(e, n) {
        if ("" === n) return e;
        var t = n.indexOf(".");

        if (t > -1) {
          var r = e[unescapeKeyPathComponent(n.substr(0, t))];
          return void 0 === r ? void 0 : getByKeyPath(r, n.substr(t + 1));
        }

        return e[unescapeKeyPathComponent(n)];
      }

      function Undefined() {}

      function TypesonPromise(e) {
        this.p = new Promise(e);
      }

      TypesonPromise.prototype.then = function (e, n) {
        var t = this;
        return new TypesonPromise(function (r, i) {
          t.p.then(function (n) {
            r(e ? e(n) : n);
          }, function (e) {
            t.p.catch(function (e) {
              return n ? n(e) : Promise.reject(e);
            }).then(r, i);
          });
        });
      }, TypesonPromise.prototype.catch = function (e) {
        return this.then(null, e);
      }, TypesonPromise.resolve = function (e) {
        return new TypesonPromise(function (n) {
          n(e);
        });
      }, TypesonPromise.reject = function (e) {
        return new TypesonPromise(function (n, t) {
          t(e);
        });
      }, ["all", "race"].map(function (e) {
        TypesonPromise[e] = function (n) {
          return new TypesonPromise(function (t, r) {
            Promise[e](n.map(function (e) {
              return e.p;
            })).then(t, r);
          });
        };
      }), Typeson.Undefined = Undefined, Typeson.Promise = TypesonPromise, Typeson.isThenable = isThenable, Typeson.toStringTag = toStringTag, Typeson.hasConstructorOf = hasConstructorOf, Typeson.isObject = isObject, Typeson.isPlainObject = isPlainObject, Typeson.isUserObject = isUserObject, Typeson.escapeKeyPathComponent = escapeKeyPathComponent, Typeson.unescapeKeyPathComponent = unescapeKeyPathComponent, Typeson.getByKeyPath = getByKeyPath, Typeson.getJSONType = function (e) {
        return null === e ? "null" : isArray(e) ? "array" : void 0 === e ? "undefined" : _typeof(e);
      }, Typeson.JSON_TYPES = ["null", "boolean", "number", "string", "array", "object"], module.exports = Typeson;
    }, {}],
    48: [function (_dereq_, module, exports) {
      "use strict";

      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };

      function _(message, opts) {
        return (opts && opts.context ? opts.context : "Value") + " " + message + ".";
      }

      function type(V) {
        if (V === null) {
          return "Null";
        }

        switch (typeof V === "undefined" ? "undefined" : _typeof(V)) {
          case "undefined":
            return "Undefined";

          case "boolean":
            return "Boolean";

          case "number":
            return "Number";

          case "string":
            return "String";

          case "symbol":
            return "Symbol";

          case "object": // Falls through

          case "function": // Falls through

          default:
            // Per ES spec, typeof returns an implemention-defined value that is not any of the existing ones for
            // uncallable non-standard exotic objects. Yet Type() which the Web IDL spec depends on returns Object for
            // such cases. So treat the default case as an object.
            return "Object";
        }
      } // Round x to the nearest integer, choosing the even integer if it lies halfway between two.


      function evenRound(x) {
        // There are four cases for numbers with fractional part being .5:
        //
        // case |     x     | floor(x) | round(x) | expected | x <> 0 | x % 1 | x & 1 |   example
        //   1  |  2n + 0.5 |  2n      |  2n + 1  |  2n      |   >    |  0.5  |   0   |  0.5 ->  0
        //   2  |  2n + 1.5 |  2n + 1  |  2n + 2  |  2n + 2  |   >    |  0.5  |   1   |  1.5 ->  2
        //   3  | -2n - 0.5 | -2n - 1  | -2n      | -2n      |   <    | -0.5  |   0   | -0.5 ->  0
        //   4  | -2n - 1.5 | -2n - 2  | -2n - 1  | -2n - 2  |   <    | -0.5  |   1   | -1.5 -> -2
        // (where n is a non-negative integer)
        //
        // Branch here for cases 1 and 4
        if (x > 0 && x % 1 === +0.5 && (x & 1) === 0 || x < 0 && x % 1 === -0.5 && (x & 1) === 1) {
          return censorNegativeZero(Math.floor(x));
        }

        return censorNegativeZero(Math.round(x));
      }

      function integerPart(n) {
        return censorNegativeZero(Math.trunc(n));
      }

      function sign(x) {
        return x < 0 ? -1 : 1;
      }

      function modulo(x, y) {
        // https://tc39.github.io/ecma262/#eqn-modulo
        // Note that http://stackoverflow.com/a/4467559/3191 does NOT work for large modulos
        var signMightNotMatch = x % y;

        if (sign(y) !== sign(signMightNotMatch)) {
          return signMightNotMatch + y;
        }

        return signMightNotMatch;
      }

      function censorNegativeZero(x) {
        return x === 0 ? 0 : x;
      }

      function createIntegerConversion(bitLength, typeOpts) {
        var isSigned = !typeOpts.unsigned;
        var lowerBound = void 0;
        var upperBound = void 0;

        if (bitLength === 64) {
          upperBound = Math.pow(2, 53) - 1;
          lowerBound = !isSigned ? 0 : -Math.pow(2, 53) + 1;
        } else if (!isSigned) {
          lowerBound = 0;
          upperBound = Math.pow(2, bitLength) - 1;
        } else {
          lowerBound = -Math.pow(2, bitLength - 1);
          upperBound = Math.pow(2, bitLength - 1) - 1;
        }

        var twoToTheBitLength = Math.pow(2, bitLength);
        var twoToOneLessThanTheBitLength = Math.pow(2, bitLength - 1);
        return function (V, opts) {
          if (opts === undefined) {
            opts = {};
          }

          var x = +V;
          x = censorNegativeZero(x); // Spec discussion ongoing: https://github.com/heycam/webidl/issues/306

          if (opts.enforceRange) {
            if (!Number.isFinite(x)) {
              throw new TypeError(_("is not a finite number", opts));
            }

            x = integerPart(x);

            if (x < lowerBound || x > upperBound) {
              throw new TypeError(_("is outside the accepted range of " + lowerBound + " to " + upperBound + ", inclusive", opts));
            }

            return x;
          }

          if (!Number.isNaN(x) && opts.clamp) {
            x = Math.min(Math.max(x, lowerBound), upperBound);
            x = evenRound(x);
            return x;
          }

          if (!Number.isFinite(x) || x === 0) {
            return 0;
          }

          x = integerPart(x); // Math.pow(2, 64) is not accurately representable in JavaScript, so try to avoid these per-spec operations if
          // possible. Hopefully it's an optimization for the non-64-bitLength cases too.

          if (x >= lowerBound && x <= upperBound) {
            return x;
          } // These will not work great for bitLength of 64, but oh well. See the README for more details.


          x = modulo(x, twoToTheBitLength);

          if (isSigned && x >= twoToOneLessThanTheBitLength) {
            return x - twoToTheBitLength;
          }

          return x;
        };
      }

      exports.any = function (V) {
        return V;
      };

      exports.void = function () {
        return undefined;
      };

      exports.boolean = function (val) {
        return !!val;
      };

      exports.byte = createIntegerConversion(8, {
        unsigned: false
      });
      exports.octet = createIntegerConversion(8, {
        unsigned: true
      });
      exports.short = createIntegerConversion(16, {
        unsigned: false
      });
      exports["unsigned short"] = createIntegerConversion(16, {
        unsigned: true
      });
      exports.long = createIntegerConversion(32, {
        unsigned: false
      });
      exports["unsigned long"] = createIntegerConversion(32, {
        unsigned: true
      });
      exports["long long"] = createIntegerConversion(64, {
        unsigned: false
      });
      exports["unsigned long long"] = createIntegerConversion(64, {
        unsigned: true
      });

      exports.double = function (V, opts) {
        var x = +V;

        if (!Number.isFinite(x)) {
          throw new TypeError(_("is not a finite floating-point value", opts));
        }

        return x;
      };

      exports["unrestricted double"] = function (V) {
        var x = +V;
        return x;
      };

      exports.float = function (V, opts) {
        var x = +V;

        if (!Number.isFinite(x)) {
          throw new TypeError(_("is not a finite floating-point value", opts));
        }

        if (Object.is(x, -0)) {
          return x;
        }

        var y = Math.fround(x);

        if (!Number.isFinite(y)) {
          throw new TypeError(_("is outside the range of a single-precision floating-point value", opts));
        }

        return y;
      };

      exports["unrestricted float"] = function (V) {
        var x = +V;

        if (isNaN(x)) {
          return x;
        }

        if (Object.is(x, -0)) {
          return x;
        }

        return Math.fround(x);
      };

      exports.DOMString = function (V, opts) {
        if (opts === undefined) {
          opts = {};
        }

        if (opts.treatNullAsEmptyString && V === null) {
          return "";
        }

        if ((typeof V === "undefined" ? "undefined" : _typeof(V)) === "symbol") {
          throw new TypeError(_("is a symbol, which cannot be converted to a string", opts));
        }

        return String(V);
      };

      exports.ByteString = function (V, opts) {
        var x = exports.DOMString(V, opts);
        var c = void 0;

        for (var i = 0; (c = x.codePointAt(i)) !== undefined; ++i) {
          if (c > 255) {
            throw new TypeError(_("is not a valid ByteString", opts));
          }
        }

        return x;
      };

      exports.USVString = function (V, opts) {
        var S = exports.DOMString(V, opts);
        var n = S.length;
        var U = [];

        for (var i = 0; i < n; ++i) {
          var c = S.charCodeAt(i);

          if (c < 0xD800 || c > 0xDFFF) {
            U.push(String.fromCodePoint(c));
          } else if (0xDC00 <= c && c <= 0xDFFF) {
            U.push(String.fromCodePoint(0xFFFD));
          } else if (i === n - 1) {
            U.push(String.fromCodePoint(0xFFFD));
          } else {
            var d = S.charCodeAt(i + 1);

            if (0xDC00 <= d && d <= 0xDFFF) {
              var a = c & 0x3FF;
              var b = d & 0x3FF;
              U.push(String.fromCodePoint((2 << 15) + (2 << 9) * a + b));
              ++i;
            } else {
              U.push(String.fromCodePoint(0xFFFD));
            }
          }
        }

        return U.join("");
      };

      exports.object = function (V, opts) {
        if (type(V) !== "Object") {
          throw new TypeError(_("is not an object", opts));
        }

        return V;
      }; // Not exported, but used in Function and VoidFunction.
      // Neither Function nor VoidFunction is defined with [TreatNonObjectAsNull], so
      // handling for that is omitted.


      function convertCallbackFunction(V, opts) {
        if (typeof V !== "function") {
          throw new TypeError(_("is not a function", opts));
        }

        return V;
      }

      [Error, ArrayBuffer, // The IsDetachedBuffer abstract operation is not exposed in JS
      DataView, Int8Array, Int16Array, Int32Array, Uint8Array, Uint16Array, Uint32Array, Uint8ClampedArray, Float32Array, Float64Array].forEach(function (func) {
        var name = func.name;
        var article = /^[AEIOU]/.test(name) ? "an" : "a";

        exports[name] = function (V, opts) {
          if (!(V instanceof func)) {
            throw new TypeError(_("is not " + article + " " + name + " object", opts));
          }

          return V;
        };
      }); // Common definitions

      exports.ArrayBufferView = function (V, opts) {
        if (!ArrayBuffer.isView(V)) {
          throw new TypeError(_("is not a view on an ArrayBuffer object", opts));
        }

        return V;
      };

      exports.BufferSource = function (V, opts) {
        if (!(ArrayBuffer.isView(V) || V instanceof ArrayBuffer)) {
          throw new TypeError(_("is not an ArrayBuffer object or a view on one", opts));
        }

        return V;
      };

      exports.DOMTimeStamp = exports["unsigned long long"];
      exports.Function = convertCallbackFunction;
      exports.VoidFunction = convertCallbackFunction;
    }, {}]
  }, {}, [1])(1);
});